import Notiflix from "notiflix";
import cnt from "./definedConstant";
import appLabel from "../config/appLabel";
import axios from "axios";
import appConfig from "../config/appConfig";
import { history } from "../history";
import { store } from "../redux/storeOf";
import Cookies from "js-cookie";
import { AlertMsg as ShowModal } from "../components/FeedbackModal";
import dayjs from "dayjs";
import devModuleLicensingConfig from "../services/moduleLicensingDev.json";
import proModuleLicensingConfig from "../services/moduleLicensingProd.json";
/** BM (Block Of Methods) */

// let currentLicensingConfig = moduleLicensingConfig;

let currentLicensingConfig = appConfig.isProduction
  ? proModuleLicensingConfig
  : devModuleLicensingConfig;
export const BOM = {
  // Check if a module is licensed/enabled

  IsModuleLicensed: (menuKey) => {
    menuKey = menuKey ? menuKey.trim() : "";

    // Try to get licensing from Redux first
    const licensingData = store?.getState()?.AuthenticationData?.userData?.licensingConfig;

    // Fallback to local config if not in Redux (for development/testing)
    const config = licensingData || currentLicensingConfig;

    if (!config || !config.licensedModules) {
      return true;
    }

    const { finSysCore = [], finSysWallet = [] } = config.licensedModules;
    const allModules = [...finSysCore, ...finSysWallet];

    const module = allModules.find((m) => m.menuKey === menuKey || m.id === menuKey);

    if (!module) {
      return false;
    }

    return module.status === "ENABLED" ? true : false;
  },

  // Get all enabled modules
  GetEnabledModules: () => {
    const licensingData = store?.getState()?.AuthenticationData?.userData?.licensingConfig;
    const config = licensingData || currentLicensingConfig;

    if (!config || !config.licensedModules) {
      return [];
    }

    const { finSysCore = [], finSysWallet = [] } = config.licensedModules;
    const allModules = [...finSysCore, ...finSysWallet];

    const enabledModules = allModules
      .filter((module) => module.status === "ENABLED")
      .map((module) => module.menuKey || module.id);

    return enabledModules;
  },

  //  Initialize licensing configuration from backend response
  InitializeModuleLicensing: (licensingConfig) => {
    if (licensingConfig) {
      currentLicensingConfig = licensingConfig;
    }
  },

  //  Get institution name from licensing config (from Redux)
  GetInstitutionName: () => {
    const licensingData = store?.getState()?.AuthenticationData?.userData?.licensingConfig;
    const config = licensingData || currentLicensingConfig;

    if (!config || !config.user) {
      return "Unknown Institution";
    }
    return config.user.institution || "Unknown";
  },

  //  Get full license info from Redux
  GetLicenseInfo: () => {
    const licensingData = store?.getState()?.AuthenticationData?.userData?.licensingConfig;
    const config = licensingData || currentLicensingConfig;

    return {
      user: config?.user || null,
      institution: config?.user?.institution || "Unknown",
      licenseType: config?.licenseType || "standard",
      isValid: !config?.expiryDate || new Date(config.expiryDate) > new Date(),
      expiryDate: config?.expiryDate || null,
    };
  },

  HasPermission: (permission) => {
    permission = permission ? permission.trim() : "";
    const permissionList = store?.getState()?.AuthenticationData?.userData?.permissions;

    //If user is a Super user return true
    if (permissionList && permissionList.find((item) => item === "ALL_FUNCTIONS")) {
      return true;
    } else if (permissionList && permission && permission !== "") {
      //If user have all read permission return true
      if (
        permission.substring(0, 5) === "READ_" &&
        permissionList.find((item) => item === "ALL_FUNCTIONS_READ")
      ) {
        return true;
      } else if (permissionList.find((item) => item === permission)) {
        //check for the permission if user doesn't have any special permissions
        return true;
      } else {
        //return false if user doesn't have permission
        return false;
      }
    } else {
      //return false if no value assigned to has-permission directive
      return false;
    }
  },
  RightBtnAction: (btnType) => {
    // console.log(btnType);
    store.dispatch({
      type: btnType,
    });
  },
  Greet: () => {
    var today = new Date();
    var curHr = today.getHours();

    if (curHr >= 0 && curHr < 6) {
      return "Good day, ";
    } else if (curHr >= 6 && curHr < 12) {
      return "Good morning, ";
    } else if (curHr >= 12 && curHr < 17) {
      return "Good afternoon, ";
    } else {
      return "Good evening, ";
    }
  },
  DisabledAfterCurrentDate: (current) => {
    return current && current.valueOf() > Date.now();
  },
  GetDayOfWeek: (date) => {
    const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    const d = date ? new Date(date) : new Date();
    return days[d.getDay()];
  },
  DisableBeforeCurrentDate: (current) => {
    return current && current < dayjs().startOf("day");
  },
  SubstringFormat: (str, end) => {
    const start = 0;
    return str.length <= end ? str : `${str.substring(start, end)}...`;
  },
  FormatArrayTime: (arrayParam) => {
    if (!arrayParam) return;

    let hour = arrayParam[0];
    let minute = arrayParam[1];
    let second = arrayParam[2];

    return dayjs().hour(hour).minute(minute).second(second);
  },
  FormatArrayDate: (arrayParam) => {
    if (!arrayParam) return;

    let year = arrayParam[0];
    let month = arrayParam[1];
    let day = arrayParam[2];

    if (day < 10) {
      day = "0" + day;
    }
    if (month < 10) {
      month = "0" + month;
    }

    return (year + "-" + month + "-" + day).toString();
  },
  FormatArrayDateWithoutYear: (arrayParam) => {
    if (!arrayParam) return;

    let currentDate = new Date();
    let year, month, day;

    if (arrayParam.length === 2) {
      year = currentDate.getFullYear();
      month = arrayParam[0];
      day = arrayParam[1];
    } else {
      year = arrayParam[0];
      month = arrayParam[1];
      day = arrayParam[2];
    }

    if (day < 10) {
      day = "0" + day;
    }
    if (month < 10) {
      month = "0" + month;
    }

    return `${year}-${month}-${day}`;
  },
  handleReqFldMsg: (key) => {
    return key + " is required.";
  },
  handlePlaceholderMsg: (key, keyType = null) => {
    // return `${label ? label : appLabel.pleaseSelect} ${key}`;
    switch (keyType) {
      case "select":
        return `${appLabel.pleaseSelect} ${key}`;
      default:
        return `${appLabel.pleaseEnter} ${key}`;
    }
  },
  handleSuccessMsg: (key) => {
    return `${key} was successfully updated`;
  },

  IsProductionUrl: (serviceType) => {
    const isProduction = appConfig.isProduction;
    switch (serviceType) {
      case "treasury":
        return isProduction ? appConfig.baseURL.treasury.prod : appConfig.baseURL.treasury.dev;
      case "teller":
        return isProduction ? appConfig.baseURL.teller.prod : appConfig.baseURL.teller.dev;
      case "wallet":
        return isProduction ? appConfig.baseURL.wallet.prod : appConfig.baseURL.wallet.dev;
      case "fineract":
      default:
        return isProduction ? appConfig.baseURL.fineract.prod : appConfig.baseURL.fineract.dev;
    }
  },

  baseUrl: (apiParam, serviceType = "fineract") => {
    return `${BOM.IsProductionUrl(serviceType)}/${apiParam}`;
  },

  RegExValidation: (key) => {
    switch (key.toLowerCase()) {
      case "only-number":
        return /^[0-9]+$/;
      case "email":
        return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      case "password":
        return /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[!?@#$%^&*/{};:,<>`])[a-zA-Z0-9!?@#$%^&*/{};:,<>`]{6,16}$/;
      case "phone":
        return /^[\+]?[1-9][\d]{0,15}$/;
      case "phone-us":
        return /^(\+1-?)?(\([0-9]{3}\)|[0-9]{3})[-.\s]?[0-9]{3}[-.\s]?[0-9]{4}$/;
      case "name":
      case "firstname":
      case "lastname":
      case "middlename":
        return /^[a-zA-Z\s'-]{2,50}$/;
      case "externalid":
        return /^[a-zA-Z0-9]+$/;
      case "username":
        return /^[a-zA-Z0-9_-]{3,20}$/;
      case "url":
        return /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?$/;
      case "zip-code":
        return /^\d{5}(-\d{4})?$/;
      case "decimal":
        return /^\d+(\.\d{1,2})?$/;
      case "strong-password":
        return /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?])(?!.*password)(?!.*\b(firstname|lastname|username)\b).{12,}$/i;

      default:
        return null;
    }
  },

  getValidationMessage: (validationType) => {
    const nameMessage =
      "Name must be 2-50 characters, letters only with spaces, apostrophes, or hyphens";

    const messages = {
      "only-number": "Please enter numbers only",
      email: "Please enter a valid email address",
      password:
        "Password must be 6-16 characters with uppercase, lowercase, number, and special character",
      phone: "Please enter a valid phone number",
      "phone-us": "Please enter a valid US phone number (e.g., (555) 123-4567)",
      name: nameMessage,
      firstname: nameMessage,
      lastname: nameMessage,
      middlename: nameMessage,
      username: "Username must be 3-20 characters with letters, numbers, underscore, or hyphen",
      url: "Please enter a valid URL",
      "zip-code": "Please enter a valid ZIP code (e.g., 12345 or 12345-6789)",
      decimal: "Please enter a valid decimal number",
      "strong-password": `Password must be at least 12 characters with uppercase, lowercase, number, and special character. Additionally, it must not contain any part of your username, first name, or last name, or the word "Password"`,
    };
    return messages[validationType.toLowerCase()] || "Invalid input format";
  },

  fieldRules: function (validationType, required = true, customMessage = null) {
    const rules = [];

    if (required) {
      rules.push({
        required: true,
        message: `This field is required!`,
      });
    }

    const regex = BOM.RegExValidation(validationType);
    if (regex) {
      rules.push({
        pattern: regex,
        message: customMessage || BOM.getValidationMessage(validationType),
      });
    }

    return rules;
  },

  handleCheckerApprovalResponse: (res, options = {}) => {
    if (res?.commandId && options.showCheckerModal && options.navigate) {
      // Show checker modal and handle navigation
      options.showCheckerModal(() => {
        options.navigate("/detail-checker-inbox", {
          state: { id: res.commandId },
        });
      });

      // After modal interaction, also navigate to the intended destination
      if (options.onCheckerApproval) {
        options.onCheckerApproval(res);
      }

      return true;
    }
    return false;
  },

  FetchReqAction: async (body, apiUrl, callback, options = {}) => {
    const { headers } = appConfig.apiSettings;
    headers.Authorization = body.session;

    const tfaToken = Cookies.get("tfaToken");
    console.log(tfaToken, "tfaToken");

    if (tfaToken && tfaToken !== "null" && tfaToken !== "undefined") {
      headers["Fineract-Platform-TFA-Token"] = tfaToken;
    } else {
      delete headers["Fineract-Platform-TFA-Token"];
    }

    const method = body?.method ? body?.method : "GET";
    const params = body?.params ? body?.params : {};

    delete body?.session;
    delete body?.method;
    delete body?.params;

    var config = {
      method,
      url: apiUrl,
      headers,
      data: body,
      params,
    };

    axios(config)
      .then(function (response) {
        let res = response?.data;
        const checkerHandled = BOM.handleCheckerApprovalResponse(res, options);

        if (!checkerHandled) {
          callback(null, res);
        } else {
          if (options.onCheckerApproval) {
            options.onCheckerApproval(res);
          }
        }
      })
      // BOM.handleCheckerApprovalResponse(res, options);
      // callback(null, res);
      // })
      .catch(function (error) {
        if (error.response) {
          callback(error.response.data);
          console.log(
            "catch 1 section: The request was made and the server responded with a status code",
          );
        } else if (error.request) {
          console.log("catch 2 section: The request was made but no response was received");
          BOM.AlertMsg(cnt.FAILURE, appLabel.smthWentWrong);
        }
      });
  },

  SessionLessReqAction: async (body, apiUrl, callback, options = {}) => {
    const { headers } = appConfig.apiSettings;

    if (options.includeIP) {
      try {
        const ipResponse = await axios.get("https://ipapi.co/json/", {
          timeout: 5000,
        });
        appConfig.apiSettings.headers["Finsys-Client-IP"] = ipResponse.data.ip || "";
      } catch (ipError) {
        console.warn("Could not fetch IP information:", ipError);
        appConfig.apiSettings.headers["Finsys-Client-IP"] = "";
        console.log("IP fetch failed - empty values set to prevent breaks");
      }
    }

    var config = {
      method: "post",
      url: apiUrl,
      headers,
      data: body,
    };

    axios(config)
      .then(function (response) {
        let res = response?.data;
        callback(null, res);
      })
      .catch(function (error) {
        if (error?.response) {
          callback(error?.response?.data, null);
        } else {
          BOM.AlertMsg(cnt.DANGER, appLabel.smthWentWrong);
        }
      });
  },

  AlertMsg: (type, message) => {
    try {
      console.log("AlertMsg called with:", { type, message });

      let mappedType = "info";
      switch (type) {
        case cnt.SUCCESS:
          mappedType = "success";
          break;
        case cnt.WARNING:
          mappedType = "warning";
          break;
        case cnt.DANGER:
          mappedType = "error";
          break;
        case cnt.INFO:
          mappedType = "info";
          break;
        case cnt.COPIED:
          mappedType = "copied";
          break;
        default:
          mappedType = "warning";
      }

      ShowModal(mappedType, message || "An error occurred");
    } catch (error) {
      console.error("Error in BOM.AlertMsg:", error);
      ShowModal("error", "An unexpected error occurred");
    }
  },

  NotifyAlert: (type, message) => {
    Notiflix.Loading.remove();
    try {
      switch (type) {
        case cnt.WARNING:
          return Notiflix.Notify.warning(message);
        case cnt.SUCCESS:
          return Notiflix.Notify.success(message);
        case cnt.DANGER:
          return Notiflix.Notify.failure(message);
        case cnt.INFO:
          return Notiflix.Notify.info(message);
        case cnt.COPIED:
          return Notiflix.Notify.success(message);
        default:
          return Notiflix.Notify.warning(message);
      }
    } catch (error) {
      console.log("error wow: ", error);
    }
  },
  LoadAlert: (type, message) => {
    try {
      switch (type.toLowerCase()) {
        case cnt.PROCESS:
          return Notiflix.Loading.dots(message + "...");
        case cnt.LOAD:
          return Notiflix.Loading.dots(message + "...");
        default:
          return Notiflix.Loading.dots(message + "...");
      }
    } catch (error) {
      console.log("error on loadingAlert func: ", error);
    }
  },
  GetBrowserName: () => {
    if ((navigator.userAgent.indexOf("Opera") || navigator.userAgent.indexOf("OPR")) !== -1) {
      return "Opera";
    } else if (navigator.userAgent.indexOf("Chrome") !== -1) {
      return "Chrome";
    } else if (navigator.userAgent.indexOf("Safari") !== -1) {
      return "Safari";
    } else if (navigator.userAgent.indexOf("Firefox") !== -1) {
      return "Firefox";
    } else if (navigator.userAgent.indexOf("MSIE") !== -1 || !document.documentMode === true) {
      return "Internet Explorer";
    } else {
      return "Not sure!";
    }
  },
  GenerateTimestamp: () => {
    // get uniq time for a document sent;
    var now = new Date();
    var timestamp = now.getFullYear().toString();
    timestamp += (now.getMonth() + 1).toString();
    timestamp += now.getDate().toString() + "";
    timestamp += now.getHours().toString();
    timestamp += now.getMinutes().toString();
    timestamp += now.getSeconds().toString();
    timestamp += now.getMilliseconds().toString();
    return timestamp;
  },
  GenerateRandomString: (length = 10, options = {}) => {
    // Generate random unique characters or numbers of customizable length
    // Options:
    //   - includeNumbers: boolean (default: true)
    //   - includeLetters: boolean (default: true)
    //   - includeUppercase: boolean (default: true)
    //   - includeLowercase: boolean (default: true)
    //   - includeSpecialChars: boolean (default: false)

    const {
      includeNumbers = true,
      includeLetters = true,
      includeUppercase = true,
      includeLowercase = true,
      includeSpecialChars = false,
    } = options;

    let charset = "";

    if (includeNumbers) {
      charset += "0123456789";
    }
    if (includeLetters) {
      if (includeUppercase) {
        charset += "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
      }
      if (includeLowercase) {
        charset += "abcdefghijklmnopqrstuvwxyz";
      }
    }
    if (includeSpecialChars) {
      charset += "!@#$%^&*()_+-=[]{}|;:,.<>?";
    }

    // If no charset is available, default to alphanumeric
    if (!charset) {
      charset = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    }

    let result = "";
    const charsetLength = charset.length;

    // Use crypto.getRandomValues for better randomness if available
    if (typeof window !== "undefined" && window.crypto && window.crypto.getRandomValues) {
      const randomValues = new Uint32Array(length);
      window.crypto.getRandomValues(randomValues);
      for (let i = 0; i < length; i++) {
        result += charset[randomValues[i] % charsetLength];
      }
    } else {
      // Fallback to Math.random
      for (let i = 0; i < length; i++) {
        result += charset[Math.floor(Math.random() * charsetLength)];
      }
    }

    return result;
  },
  GetUnique: (arr, comp) => {
    // store the comparison  values in array
    const unique = arr
      .map((e) => e[comp])

      // store the indexes of the unique objects
      .map((e, i, final) => final.lastIndexOf(e) === i && i)

      // eliminate the false indexes & return unique objects
      .filter((e) => arr[e])
      .map((e) => arr[e]);

    return unique;
  },
  RmvAccentOnly: (str_param) => {
    // str_param.replace(/\s+/g, " ");
    let mystr = str_param.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    return mystr; //.replace(/'/g, "A");
  },
  GetWindowData: (key, option = "") => {
    switch (key.toLowerCase()) {
      case "origin":
        return window.location.origin + option;
      case "host":
        return window.location.host;
      case "hostname":
        return window.location.hostname;
      case "href":
        return window.location.href;
      case "pathname":
        return window.location.pathname;
      case "port":
        return window.location.port;
      case "protocol":
        return window.location.protocol;
      default:
        return window.location.origin;
    }
  },
  Uwfirst: (str) => {
    return str.toLowerCase().replace(/^\w|\s\w/g, function (letter) {
      return letter.toUpperCase();
    });
  },

  GlobalApproveRejectAction: (body, reqUrl, redirectUrl, label, action) => {
    Notiflix.Confirm.show(
      "Are you sure?",
      action + label,
      "Yes",
      "No",
      function () {
        // Yes
        BOM.LoadAlert(cnt.LOAD, "Processing");
        BOM.FetchReqAction(body, reqUrl, (err, res) => {
          if (err) {
            BOM.AlertMsg(cnt.DANGER, err.message || err.error);
          } else {
            BOM.AlertMsg(cnt.SUCCESS, res.message);
            // history.push(redirectUrl);
          }
        });
      },
      function () {
        // No button
      },
    );
  },
  ApproveRejectWithReload: (body, reqUrl, label, action) => {
    Notiflix.Confirm.show(
      action + label,
      "Are you sure?",
      "Yes",
      "No",
      function () {
        // Yes
        BOM.LoadAlert(cnt.LOAD, "Processing");
        BOM.SendReqActWithReload(body, reqUrl);
      },
      function () {
        // No button
      },
    );
  },
  LoadTimeout: () => {
    Notiflix.Loading.remove();
  },
  SystemTimeout: (param) => {
    return setTimeout(() => {
      BOM.LoadTimeout();
      console.log(`timeout occured on: ${param.toUpperCase()} request API`);
      Notiflix.Report.warning(
        "WARNING",
        "The server encountered something unexpected that didn't allow it to complete the request. We apologize.",
        "OK",
      );
    }, 60000);
  },
  CurrentDate: () => {
    let today = new Date();
    let dd = today.getDate();
    let mm = today.getMonth() + 1;
    let yyyy = today.getFullYear();
    if (dd < 10) {
      dd = "0" + dd;
    }
    if (mm < 10) {
      mm = "0" + mm;
    }
    return (yyyy + "-" + mm + "-" + dd).toString();
  },
  handleFileRead: async (event, setState_param) => {
    const file = event.target.files[0];
    if (!file) {
      // if file is empty
      setState_param("");
      return;
    }

    const base64 = await BOM.convertBase64(file);
    let strB64 = base64.split("base64,")[1]; //.replace(/^data:image\/[a-z]+;base64,/, "");
    setState_param(strB64);
    console.log(strB64);
  },
  convertBase64: (file) => {
    if (!file) {
      return;
    }
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        resolve(fileReader.result);
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  },
  DownloadAction: (base64File, fileName) => {
    fileName = BOM.ReplaceSpace(fileName, "_");
    let fileType = BOM.DetectMimeType(base64File);

    const source = "data:" + fileType + ";base64," + base64File;

    const downloadLink = document.createElement("a");

    downloadLink.href = source;
    downloadLink.download = fileName.replace(/ /g, ""); // rename your file
    downloadLink.click();
  },
  DetectMimeType: (b64) => {
    let signatures = {
      JVBERi0: "application/pdf",
      iVBORw0KGgo: "image/png",
      "/9j/4AAQSkZJRgABAQ": "image/jpeg",
    };
    for (var s in signatures) {
      if (b64.indexOf(s) === 0) {
        return signatures[s];
      }
    }
  },
  ReplaceSpace: (str, character) => {
    return str.replace(/ /g, character);
  },
  ReformatDate: (dateParam) => {
    dateParam = new Date(dateParam);
    let dd = dateParam.getDate();
    let mm = dateParam.getMonth() + 1;
    let yyyy = dateParam.getFullYear();
    if (dd < 10) {
      dd = "0" + dd;
    }
    if (mm < 10) {
      mm = "0" + mm;
    }
    return (yyyy + "-" + mm + "-" + dd).toString();
  },
  addDaysInDate: (dateParam, param = 0) => {
    const aDay = 60 * 60 * 24 * 1000; // seconds * minutes * hours * milliseconds = 1 day
    dateParam = new Date(dateParam.getTime() + aDay * param);
    let dd = dateParam.getDate();
    let mm = dateParam.getMonth() + 1;
    let yyyy = dateParam.getFullYear();
    if (dd < 10) {
      dd = "0" + dd;
    }
    if (mm < 10) {
      mm = "0" + mm;
    }
    return (yyyy + "-" + mm + "-" + dd).toString();
  },
  DateTime: (myDate, keyParam) => {
    myDate = new Date(myDate);

    let daysList = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    let monthsList = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    let date = myDate.getDate();
    let month = monthsList[myDate.getMonth()];
    let year = myDate.getFullYear();
    let day = daysList[myDate.getDay()];

    let today = `${day} ${date} ${month} ${year}`;
    let onlyDate = `${date} ${month} ${year}`;

    let amOrPm;
    let twelveHours = function () {
      if (myDate.getHours() > 12) {
        amOrPm = "PM";
        let twentyFourHourTime = myDate.getHours();
        let conversion = twentyFourHourTime - 12;
        return `${conversion}`;
      } else {
        amOrPm = "AM";
        return `${myDate.getHours()}`;
      }
    };
    let hours = twelveHours();
    let minutes = myDate.getMinutes();
    let second = myDate.getSeconds().toString();

    let currentTime = `${hours}:${minutes}:${second} ${amOrPm.toLowerCase()}`;

    // console.log(today + " " + currentTime);

    switch (keyParam) {
      case "only-date":
        return onlyDate;
      case "date-time":
        return currentTime + " - " + today;
      case "with-seconds":
        return `${currentTime}`;
      case "iso-date": {
        // Return date in yyyy-MM-dd format
        let isoMonth = (myDate.getMonth() + 1).toString().padStart(2, "0");
        let isoDay = date.toString().padStart(2, "0");
        return `${year}-${isoMonth}-${isoDay}`;
      }

      default:
        return today;
    }
  },
  DateTimeWithoutYear: (myDate, keyParam) => {
    myDate = new Date(myDate);

    const daysList = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    const monthsList = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    const date = myDate.getDate();
    const month = monthsList[myDate.getMonth()];
    const day = daysList[myDate.getDay()];

    const today = `${day} ${date} ${month}`;
    const onlyDate = `${date} ${month}`;

    let amOrPm;
    const twelveHours = () => {
      const hours = myDate.getHours();
      if (hours > 12) {
        amOrPm = "PM";
        return `${hours - 12}`;
      } else {
        amOrPm = "AM";
        return `${hours}`;
      }
    };

    const hours = twelveHours();
    const minutes = myDate.getMinutes().toString().padStart(2, "0");
    const seconds = myDate.getSeconds().toString().padStart(2, "0");

    const currentTime = `${hours}:${minutes}:${seconds} ${amOrPm.toLowerCase()}`;

    switch (keyParam) {
      case "only-date":
        return onlyDate;
      case "date-time":
        return `${currentTime} - ${today}`;
      default:
        return today;
    }
  },
  ReloadComponent: () => {
    window.location.reload(false);
  },
  ValidateNaNValue: (valueParam, labelParam) => {
    valueParam = parseFloat(valueParam);
    let isNaNVal = false;

    if (Number.isNaN(valueParam)) {
      BOM.AlertMsg(cnt.WARNING, labelParam + " is not a valid number.");
      isNaNVal = true;
    }

    if (isNaNVal) return 1;
    else return 0;
  },
  CheckReqFld: (key) => {
    return key + appLabel.isRequired;
  },

  MaskingString: (str, start, end) => {
    if (!str || start < 0 || start >= str.length || end < 0 || end > str.length || start >= end) {
      return str;
    }
    const maskLength = end - start;
    const maskedStr = str.substring(0, start) + "*".repeat(maskLength) + str.substring(end);
    return maskedStr;
  },
  OnError: (errors) => {
    BOM.AlertMsg(cnt.DANGER, appLabel.fldWithAsteRq);
    console.log(errors);
  },
  FormatAmount: (value) => {
    if (value === null || value === undefined || value === "") return "";
    return `${value}`.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  },

  ParseAmount: (value) => {
    return value?.toString().replace(/,/g, "") || "";
  },

  formatNumber: (num, precision = 2) => {
    const map = [
      { suffix: "T", threshold: 1e12 },
      { suffix: "B", threshold: 1e9 },
      { suffix: "M", threshold: 1e6 },
      { suffix: "K", threshold: 1e3 },
      { suffix: "", threshold: 1 },
    ];

    const found = map.find((x) => Math.abs(num) >= x.threshold);
    if (found) {
      const formatted = (num / found.threshold).toFixed(precision) + found.suffix;
      return formatted;
    }

    return parseFloat(num);
  },
};

/** initialise notiflix pop up */
export const notifInitialization = () => {
  Notiflix.Confirm.init({
    className: "notiflix-confirm",
    width: "300px",
    zindex: 4003,
    position: "center",
    distance: "10px",
    backgroundColor: "#f8f8f8",
    borderRadius: "25px",
    backOverlay: true,
    backOverlayColor: "rgba(0,0,0,0.5)",
    rtl: false,
    fontFamily: "Quicksand",
    cssAnimation: true,
    cssAnimationDuration: 300,
    cssAnimationStyle: "fade",
    plainText: true,
    titleColor: "#92428B",
    titleFontSize: "16px",
    titleMaxLength: 34,
    messageColor: "#1e1e1e",
    messageFontSize: "14px",
    messageMaxLength: 200,
    buttonsFontSize: "15px",
    buttonsMaxLength: 34,
    okButtonColor: "#f8f8f8",
    okButtonBackground: "#92428B",
    cancelButtonColor: "#f8f8f8",
    cancelButtonBackground: "#a9a9a9",
  });
};
